require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nelle-scuole-del-cantone-ticino-1945-1980-venezia-7-maggio-2019.json") })
        }
      }, "path---en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nelle-scuole-del-cantone-ticino-1945-1980-venezia-7-maggio-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nelle-scuole-del-cantone-ticino-1945-1980-venezia-7-maggio-2019!./.cache/json/en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nelle-scuole-del-cantone-ticino-1945-1980-venezia-7-maggio-2019.json
// module id = 615
// module chunks = 231608221292675